import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import React from 'react'

const CustomHeaderIcon = ({customIcon, onClick}) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));
    return (
      <img style={{ width: "4.5rem", height: "4.5rem", marginInline:  isSmallScreen || isMediumScreen  ? "auto" : 0, cursor: onClick ? 'pointer' : 'initial' }} src={customIcon} onClick={onClick ? onClick : () => {}} />
    )
}

export default CustomHeaderIcon